import companyService from "../services/company.service";

const companies = {
    namespaced: true,
    state: {
        bankAccountTypes: null,
        companyStatuses: null,
        companyContactDesignations: null,
    },
    actions: {
        //CREATE
        create(_, formData) {
            return companyService.create(formData);
        },
        addNote(_, params) {
            return companyService.addNote(params.companyId, params.text);
        },

        sendwelcomesmstocompanycontactpersons(_, params) {
            return companyService.sendwelcomesmstocompanycontactpersons(params);
        },
        //READ
        get(_, params) {
            return companyService.get(params.id, params.urlParameters, params.requestId);
        },
        getlist() {
            return companyService.getlist();
        },

        async getCompanyStatuses({commit, state, getters}) {
            if (state.companyStatuses === null) {
                var response = await companyService.getCompanyStatuses();
                commit("setCompanyStatuses", response.data);
            }
            return getters.companyStatuses;
        },

        async getCompanyContactDesignations({commit, state, getters}) {
            if (state.companyContactDesignations === null) {
                var response = await companyService.getCompanyContactDesignations();
                commit("setCompanyContactDesignations", response.data);
            }
            return getters.companyContactDesignations;
        },
        async getCompanyPaymentPreferences({commit, state, getters}) {
            if (state.companyContactDesignations === null) {
                var response = await companyService.getCompanyContactDesignations();
                commit("setCompanyContactDesignations", response.data);
            }
            return getters.companyContactDesignations;
        },

        //UPDATE
        update(_, params) {
            return companyService.update(params.id, params.formData);
        },
        async getbankaccounttypes({commit, state, getters}) {
            if (state.bankAccountTypes === null) {
                var response = await companyService.getbankaccounttypes();
                commit("setBankAccountTypes", response);
            }
            return getters.bankAccountTypes;
        },

        //DELETE
        delete(_, id) {
            return companyService.delete(id);
        },
        //
        addcontact(_, params) {
            return companyService.addcontact(params.companyid, params.customercompanycontact);
        },
        updatecontact(_, params) {
            return companyService.updatecontact(params.companyid, params.customercompanycontact);
        },
        deletecontact(_, params) {
            return companyService.deletecontact(params.companyid, params.customercompanycontactid);
        },
    },
    getters: {
        bankAccountTypes: (state) => state.bankAccountTypes,
        companyStatuses: (state) => state.companyStatuses,
        companyContactDesignations: (state) => state.companyContactDesignations,
    },
    mutations: {
        setBankAccountTypes(state, types) {
            state.bankAccountTypes = types;
        },
        setCompanyStatuses(state, types) {
            state.companyStatuses = types;
        },
        setCompanyContactDesignations(state, types) {
            state.companyContactDesignations = types;
        },
    },
};

export default companies;
